import React, {  useState, useEffect } from "react";
import "./Login.css";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { TextInputComponent } from "../../common/Form/Input.component";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { setLoggedInUser } from "../../reducer/user.reducer";
import { auth, googleProvider } from "../../../firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";

const Login = ({ setCurrentView }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  // Check if user is already logged in from Redux store, not from API call
  const loggedInUser = useSelector((root) => root.user.loggedInUser);

  useEffect(() => {
    if(loggedInUser){
      return navigate('/my_account')
    }
  },[loggedInUser, navigate])

  const loginDTO = Yup.object({
    email: Yup.string().email().required(),
    password: Yup.string().required(),
  });

  const {  handleSubmit, control,formState: { errors }, } = useForm({
    resolver: yupResolver(loginDTO),
  });

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const token = await user.getIdToken();
      
      toast.success("Welcome with Google!");
      localStorage.setItem("_at", token);
      dispatch(setLoggedInUser({
        uid: user.uid,
        email: user.email,
        name: user.displayName,
        image: user.photoURL
      }));
      
      navigate('/my_account');
    } catch (error) {
      toast.error(error.message || "Google Login failed");
    } finally {
      setLoading(false);
    }
  }

  const login = async (data) => {
    setLoading(true);
    try {      
      const userCredential = await signInWithEmailAndPassword(auth, data.email, data.password);
      const user = userCredential.user;
      const token = await user.getIdToken();

      toast.success("Welcome to Maya Wears");
      localStorage.setItem("_at", token);
      dispatch(setLoggedInUser({
        uid: user.uid,
        email: user.email,
        name: user.displayName,
      }));
      
      setTimeout(() => {
        navigate('/my_account');
      }, 500);      
    } catch (exception) {      
      toast.error(exception.message || "Login failed");
    }
    finally{
      setLoading(false)
    }
  };

  return (
    <div className="login_box">
      <form action="" method="post" onSubmit={handleSubmit(login)}>
      <p>Please enter your details to Sign In</p>
        <div className="form_body">
          <label htmlFor="email">
            Email<span>*</span>
          </label>
          <br />
          <TextInputComponent
            name="email"
            errMsg={errors?.email?.message || null}
            required:true
            control={control}
          />
          <br />
          <label htmlFor="password">
            Password<span>*</span>
          </label>
          <br />
          <TextInputComponent
            name="password"
            type="password"
            errMsg={errors?.password?.message || null}
            required:true
            control={control}
          />
          <br />
          <input
            className="submit_btn hoverBotton"
            type="submit"
            value="Sign In"
            name="login_submit"
            disabled={loading}
          />
        </div>
        
      </form>
      <div className="google_login">
          <button onClick={handleGoogleLogin}>
            <span>
              <svg height="28" width="28" enable-background="new 0 0 128 128" id="Social_Icons" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="_x31__stroke"><g id="Google"><rect clip-rule="evenodd" fill="none" fill-rule="evenodd" /><path clip-rule="evenodd" d="M27.585,64c0-4.157,0.69-8.143,1.923-11.881L7.938,35.648    C3.734,44.183,1.366,53.801,1.366,64c0,10.191,2.366,19.802,6.563,28.332l21.558-16.503C28.266,72.108,27.585,68.137,27.585,64" fill="#FBBC05" fill-rule="evenodd"/><path clip-rule="evenodd" d="M65.457,26.182c9.031,0,17.188,3.2,23.597,8.436L107.698,16    C96.337,6.109,81.771,0,65.457,0C40.129,0,18.361,14.484,7.938,35.648l21.569,16.471C34.477,37.033,48.644,26.182,65.457,26.182" fill="#EA4335" fill-rule="evenodd"/><path clip-rule="evenodd" d="M65.457,101.818c-16.812,0-30.979-10.851-35.949-25.937    L7.938,92.349C18.361,113.516,40.129,128,65.457,128c15.632,0,30.557-5.551,41.758-15.951L86.741,96.221    C80.964,99.86,73.689,101.818,65.457,101.818" fill="#34A853" fill-rule="evenodd"/><path clip-rule="evenodd" d="M126.634,64c0-3.782-0.583-7.855-1.457-11.636H65.457v24.727    h34.376c-1.719,8.431-6.397,14.912-13.092,19.13l20.474,15.828C118.981,101.129,126.634,84.861,126.634,64" fill="#4285F4" fill-rule="evenodd"/></g></g></svg>
            </span>
            <strong>Login with Google</strong>
          </button>
        </div>
        <div className="sign_up_p">
          <h5 onClick={() => setCurrentView("forgotPassowrd")}>
            Forgot Password?
          </h5>
          <p>
            Don't have an account?{" "}
            <span onClick={() => setCurrentView("signup")}>Sign Up</span>
          </p>
        </div>
    </div>
  );
};

export default Login;
